import { TIME_TOKENS } from './consts';

/**
 * Determines whether `date` is a number.
 * @param date - anything
 * @returns `true` if `date` is a number
 */
export const isNumber = (date: unknown): date is number => {
  return typeof date === 'number';
};

/**
 * Checks if `value` is a valid `Date` with following conditions:
 *  - `value` is a `Date` type.
 *  - The string form of `value` does not display `"Invalid Date"`.
 *  - The numeric equivalent of `value` is not `NaN`.
 * Or if `value` is a number with the following conditions:
 *  - is not `NaN`
 * @param value - anything, literally.
 * @returns `true` if `value` is a valid `Date` object.
 */
export const isValidDate = (value: unknown) => {
  if (value instanceof Date) {
    return value.toString() !== 'Invalid Date' && !isNaN(value.valueOf());
  } else if (isNumber(value)) {
    return !isNaN(value);
  }

  return false;
};

/**
 * Attempt to convert given `locale` string to a valid BCP 47 language tag form.
 * Rely on browser language if the language is the same, but region is more specific.
 * @param locale Locale code to convert.
 */
export const getValidLocale = (locale: string | undefined): string => {
  const matchedLocale =
    locale && navigator.language.includes(locale)
      ? navigator.language
      : locale || navigator.language || 'en';

  return matchedLocale.replace(/_/g, '-');
};

/**
 * Determines whether `input` has a time zone attached to it
 * @param input - String to determine whether it has an attached time zone
 * @returns true if `input` has a time zone
 */
export const hasTimezone = (input: string): boolean => {
  let foundT = false;
  for (let i = input.length - 1; i >= 0; i--) {
    if (input[i] === 'T') {
      foundT = true;
      continue;
    }
    if (TIME_TOKENS.has(input[i]) && !foundT) {
      return true;
    }
  }
  return false;
};
